import {
  NgModule
} from '@angular/core';
import {
  ClientDetailComponent
} from './client-detail.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../../shared/common';
import {
  LoadingIndicatorModule
} from '../../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../../shared/layout/components/breadcrumb';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ConfirmDialogComponent} from '../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {VisitComponent} from './visit/visit.component';
import {NoteDialogComponent} from "./note-dialog.component";
import {MatExpansionModule} from '@angular/material/expansion';
import {ClientDialogComponent} from '../../accounts/detail/components/client-dialog/client-dialog.component';
import {SchedulerModule} from '@progress/kendo-angular-scheduler';
import {ClientSessionService} from '../client-sessions.service';
import {DurationPipe} from '../../shared/duration/duration.pipe';

@NgModule({
  declarations: [
    ClientDetailComponent,
    VisitComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    ReactiveFormsModule,
    DialogModule,
    SchedulerModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatGridListModule,
    FlexLayoutModule
  ],
  exports: [
  ],
  providers: [
    ClientSessionService,
    DurationPipe
  ],
  entryComponents: [
    ConfirmDialogComponent,
    VisitComponent,
    NoteDialogComponent,
    ClientDialogComponent
  ],
})
export class ClientDetailModule {
}
